import React from 'react';

const notpriorizedModalColumns = [
  {
    'Header': () => <span className="floating-header-title">DESCRIPCIÓN</span>,
    'accessor': 'description',
  },
  {
    'Header': () => <span className="floating-header-title">CHASIS</span>,
    'accessor': 'chassis',
  },
  {
    'Header': () => <span className="floating-header-title">CONCESIONARIO</span>,
    'accessor': 'dealerName',
  },
  {
    'Header': () => <span className="floating-header-title">CLIENTE</span>,
    'accessor': 'clientName',
  },
];

export default notpriorizedModalColumns;
